import TbAddonRecommendations from "./steps/tbAddonRecommendations";
import TbEPayment from "./steps/tbEPayment";
import TbDirectDebitDetails from "./steps/tbDirectDebitDetails";
import TbDocuments from "./steps/tbDocuments";
import BuyStep from "./enums/BuyStep";
import TbGlobalPaymentsPage from "./steps/tbGlobalPaymentsPage";
import useAppStateStore from "../../shared/store/AppStateStore";

const stepComponents = {
  [BuyStep.TB_DOCUMENTS]: TbDocuments,
  [BuyStep.TB_ADDON_RECOMMENDATIONS]: TbAddonRecommendations,
  [BuyStep.TB_E_PAYMENT]: TbEPayment,
  [BuyStep.TB_DIRECT_DEBIT_DETAILS]: TbDirectDebitDetails,
  [BuyStep.TB_GLOBAL_PAYMENTS_PAGE]: TbGlobalPaymentsPage,
};

const AllBuySteps = () => {
  const currentStep = useAppStateStore((state) => state.currentStep);
  const StepComponent = stepComponents[currentStep] || null;
  return <div>{StepComponent && <StepComponent />}</div>;
};

export default AllBuySteps;
